// src/redux/slices/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null, // User data after login
  isAuthenticated: false, // Login state
  loading: false, // For async actions
  error: null, // For handling errors
  userslist :[]
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setUsersList : (state, action) => {
        state.userslist = action.payload;
    } 
  },
});

export const { loginStart, loginSuccess, loginFailure, logout ,setUsersList} = userSlice.actions;

export default userSlice.reducer;
